import { gql, useQuery } from "@apollo/client";

export function useUserOnboardingVideos() {
    return useQuery(
        gql`
          query getUserOnboardingVideos {
            user_onboarding_videos {
              _id
              video_name
              video_id
              video_type
            }
          }
        `,
        {
          fetchPolicy : 'network-only'
        }
      );
}